import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Mail, Send, Users } from 'lucide-react';
import EmailAnalytics from './EmailAnalytics';
import LeadReports from './LeadReports';
import OutreachDashboard from './OutreachDashboard';

export default function EngagementReports() {
  const [tab, setTab] = useState('email');

  return (
    <div className="space-y-4" data-testid="engagement-reports">
      <div>
        <h1 className="text-xl font-bold">Engagement Reports</h1>
        <p className="text-sm text-muted-foreground">Email performance, outreach pipeline, and lead analytics</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList data-testid="engagement-report-tabs">
          <TabsTrigger value="email" data-testid="tab-email">
            <Mail className="w-3.5 h-3.5 mr-1.5" /> Email Analytics
          </TabsTrigger>
          <TabsTrigger value="outreach" data-testid="tab-outreach">
            <Send className="w-3.5 h-3.5 mr-1.5" /> Outreach Pipeline
          </TabsTrigger>
          <TabsTrigger value="leads" data-testid="tab-leads">
            <Users className="w-3.5 h-3.5 mr-1.5" /> Lead Report
          </TabsTrigger>
        </TabsList>

        <TabsContent value="email" className="mt-4">
          <EmailAnalytics />
        </TabsContent>

        <TabsContent value="outreach" className="mt-4">
          <OutreachDashboard />
        </TabsContent>

        <TabsContent value="leads" className="mt-4">
          <LeadReports />
        </TabsContent>
      </Tabs>
    </div>
  );
}
